import { lazy } from "react";

const KEY = "chunk-reload-at";

export const isChunkError = (e) => /Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed/i.test(String(e?.message || e?.name || e));

// After a redeploy, old chunk file names 404 for users with the previous build open. Reload once to pick up the new build.
export const recoverFromChunkError = (e) => {
  if (!isChunkError(e)) return false;
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 30000) return false;  // already reloaded recently — show the error instead of looping
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
  return true;
};

export const lazyPage = (loader) => lazy(() => loader().catch((e) => {
  if (recoverFromChunkError(e)) return new Promise(() => {});  // reload in progress — never resolve
  throw e;
}));
